import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function payableAmountGreaterThanOpenBalanceValidator(
  numberInput: number,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const controlVal =
      +control.value < 0 ? +control.value * -1 : +control.value;
    const numberInputVal = numberInput < 0 ? numberInput * -1 : numberInput;
    const isValueGreaterThan = controlVal > numberInputVal;
    return isValueGreaterThan
      ? // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        {
          isValueGreaterThanOpenBalance: {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            value: control.value,
          },
        }
      : null;
  };
}

export const shortPaymentValidator =
  (
    originalSessionPayableAmount: number,
    discountedAmount: number,
    discountLostForNonAmountReason: boolean,
  ): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null =>
    Math.abs(+control.value) < Math.abs(originalSessionPayableAmount) &&
    (Math.abs(+control.value) != discountedAmount ||
      (Math.abs(+control.value) == discountedAmount &&
        discountLostForNonAmountReason))
      ? { isShortPayment: { value: control.value as unknown } }
      : null;

export const overPaymentValidator =
  (originalSessionPayableAmount: number): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null =>
    Math.abs(+control.value) > Math.abs(originalSessionPayableAmount)
      ? { isOverPayment: { value: control.value as unknown } }
      : null;
